import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=18fae13a&scoped=true&"
import script from "./AddArticle.vue?vue&type=script&lang=js&"
export * from "./AddArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=18fae13a&lang=less&scoped=true&"
import style1 from "./AddArticle.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fae13a",
  null
  
)

export default component.exports